import { Variants as MotionVariants, Transition } from "motion/react";

const DEFAULT_DISTANCE = 48;

export const Transitions: Record<string, Transition> = {
  Default: {
    duration: 0.25,
    ease: "easeOut" as const,
  },
  Quick: {
    duration: 0.2,
    ease: "linear" as const,
  },
};

const baseTextRotation: MotionVariants = {
  initial: { opacity: 0, y: 20 },
  animate: {
    opacity: 1,
    y: 0,
    transition: Transitions.Quick,
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: Transitions.Quick,
  },
};

const baseFadeInUp: MotionVariants = {
  initial: { opacity: 0, y: DEFAULT_DISTANCE },
  animate: {
    opacity: 1,
    y: 0,
    transition: Transitions.Default,
  },
  exit: {
    opacity: 0,
    y: DEFAULT_DISTANCE,
    transition: Transitions.Default,
  },
};

const baseFadeInDown: MotionVariants = {
  initial: { opacity: 0, y: -DEFAULT_DISTANCE * 2 },
  animate: {
    opacity: 1,
    y: 0,
    transition: Transitions.Default,
  },
  exit: {
    opacity: 0,
    y: -DEFAULT_DISTANCE,
    transition: Transitions.Default,
  },
};

export const Variants: Record<string, MotionVariants> = {
  FadeInUp: baseFadeInUp,
  FadeInUpDelayed: {
    ...baseFadeInUp,
    animate: {
      ...baseFadeInUp.animate,
      transition: { ...Transitions.Default, delay: 0.2 },
    },
  },

  FadeInDown: baseFadeInDown,

  TextRotation: baseTextRotation,
};
